import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportCashReconciliationFilters, getReportCashReconciliationAction } from "redux/actions/Reports/reportCashReconciliation/reportCashReconciliationActions";

export const ReportCashReconciliationView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(({ reportCashReconciliation }) => reportCashReconciliation);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!station?.id) {
      setSnackbar("Falta planta");
      return;
    }
    dispatch(getReportCashReconciliationAction({ date, station }));
  };

  return (
    <GlobalBox title="Reporte Corte de Caja Unificado" icon={<ReceiptIcon />}>
      {isLoadingComp?.loadingReportCashReconciliation ? <LoadingComponent /> :
        <TableInputs
          reducer="reportCashReconciliation"
          date
          stations
          maxDate={newDate()}
          dispatchAction={setReportCashReconciliationFilters}
          submitAction={handleSubmit}
          submitButtonName="Descargar"
        />
      }
    </GlobalBox>
  );
};
